export function updateForm(state, payload) {
  // WE VALIDATE IF THE FORM CHANGED
  if (JSON.stringify(state.formJSON) != JSON.stringify(payload)) {
    if (state.formJSON.length != payload.length) {
      // SOMETHING WAS ADDED
      state.formJSON = payload;
      state.newField = true;
    } else {
      // SOMETHING WAS JUST EDITED
      state.formJSON = payload;
      state.newField = false;
    }
  } else {
    // IF THE FORM DIDN´T CHANGE
  }
}

export function setContent(state, payload) {
  state.formContent = payload;
}

export function setBackground(state, payload) {
  state.formBackground = payload;
}

export function saveEditFormInfo(state, payload) {
  state.currentFormInfo = payload.form;
  state.currentFormInfo.form_style = JSON.parse(
    state.currentFormInfo.form_style||'{}'
  );
  state.currentFormInfo.inputs = JSON.parse(state.currentFormInfo.inputs);
  state.currentFormInfo.id_form_course = payload.formCourse.id_form_course;
  state.currentFormInfo.privacy_form = payload.formCourse.privacy_form;
  state.currentFormCourses = payload.courses||[];
  state.currentFormUsers = payload.users||[];
}

export function isLoading(state, bool) {
  state.isLoadingForm = bool;
}

export function cleanState(state, payload) {
  state.formJSON = [];
  state.newField = false;
  state.formBackground = {};
  state.formContent = {
    formDescription: "",
    formTitle: "",
    fontColor: { hex: "#383838" },
    buttonTextColor: { hex: "#FFF" },
    buttonLabel: "",
    buttonBackground: { hex: "#00aeee" },
    formBackground: "",
    thankYouMessage: "",
    finalParagraph: "",
    buttonLabel2: "",
    buttonLink: "",
  };
  state.currentFormInfo = {};
  state.isLoadingForm = true;
}
